import { callReducers } from '@/features/calls/model';
import { chatReducers } from '@/features/chats';
import { userInfoReducers } from '@/features/users';
import { settingsReducers } from '@/features/settings/model';
import { commonReducers } from '@/app/store/commonSlice';
import { syncReducers } from '@/app/store/syncSlice';
import { featuresReducer } from '@/app/store/featuresSlice';
import { navigationReducer } from '@/app/store/navigationSlice';
import { configureStore } from '@reduxjs/toolkit';
import { authReducers } from '@/app/store/authSlice';
import { calendarReducer } from '@/features/calendar/model/calendarSlice';
import { inviteReducers } from '@/features/invite/model';

const rootReducer = {
   // Feature reducers
   ...chatReducers,
   ...userInfoReducers,
   ...settingsReducers,
   ...commonReducers,
   ...callReducers,
   ...authReducers,
   ...syncReducers,
   ...featuresReducer,
   ...inviteReducers,
   // Global slices
   navigationData: navigationReducer,
   calendarData: calendarReducer,
};

export const store = configureStore({
   reducer: rootReducer,
   middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
         serializableCheck: false,
         immutableCheck: false,
      }),
});

// Test-only handle for Playwright. Stripped from production bundles by Vite
// (import.meta.env.PROD === true → branch is dead-code-eliminated). The
// hostname check is a runtime belt-and-suspenders guard for non-prod deploys.
if (
   !import.meta.env.PROD &&
   typeof window !== 'undefined' &&
   ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname)
) {
   window.__EIM_STORE__ = store;
}
